import en from './en.json'
import ru from './ru.json'

export const DEFAULT_LANGUAGE = 'en'

export type TranslationKey = keyof typeof en

export type Language = 'en' | 'ru'

export type Catalogue = Record<TranslationKey, string>

const catalogues: Record<Language, Catalogue> = { en, ru }

export const LANGUAGES = Object.keys(catalogues) as Language[]

export function isLanguage(candidate: string | undefined): candidate is Language {
  return candidate !== undefined && (LANGUAGES as string[]).includes(candidate)
}

export function resolveLanguage(...candidates: (string | undefined)[]): Language {
  for (const candidate of candidates) {
    const base = candidate?.split('-')[0]?.toLowerCase()
    if (isLanguage(base)) {
      return base
    }
  }

  return DEFAULT_LANGUAGE
}

export function translate(
  language: Language,
  key: TranslationKey,
  params?: Record<string, string | number>,
): string {
  const template = catalogues[language][key] || catalogues[DEFAULT_LANGUAGE][key]

  if (!params) {
    return template
  }

  return template.replace(/{{(\w+)}}/g, (whole, name: string) => {
    const value = params[name]

    return value === undefined ? whole : String(value)
  })
}
